import React, { useState } from 'react';
import Lightbox from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"

const Map = ({ map }) => {
    const [open, setOpen] = useState(false)

    if (!map) return null;

    return (
        <div>
            <img
                src={map.openMap}
                className="map small-map"
                alt={map.alt}
                onClick={() => setOpen(true)}
                style={{ cursor: 'pointer' }}
            />

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={[{ src: map.openMap }]}
            />
        </div>
    );
};

export default Map;